// Presentation only: persisted names, API identifiers, and private vaults are unchanged.
export const spaceLabel = (space: { personal?: boolean; name?: string | null } | null | undefined): string => space?.personal ? 'Personal' : space?.name || 'Space'

// `todos` is people's to-dos and repeats; `tasks` is the admins' Runs view of Sunny's work, which
// is the To-dos view for anyone else.
export type SpaceView = 'todos' | 'tasks' | 'files' | 'lists' | 'chat' | 'schooling'

export function spaceView(view: string | null | undefined, { admin = false }: { admin?: boolean } = {}): SpaceView {
  if (view === 'tasks') return admin ? 'tasks' : 'todos'
  if (view === 'todos') return 'todos'
  if (view === 'files') return 'files'
  if (view === 'schooling') return 'schooling'
  if (view === 'lists' || view === 'saved') return 'lists'
  return 'chat'
}

export const householdIdeas = [
  'Plan three easy dinners.',
  'Make a packing list for a family weekend.',
  'Help us plan a weekend at home.',
]
